module.exports = __webpack_public_path__ + "img/minimize-icon.55897c6c.svg";